import React from 'react';

import {NotificationContent} from 'src/modules/internal-notification/components/notification-content';

import Button from '@pb/kit-component-button';
import {DialogFooter, DialogHeader, DialogMain} from '@pb/kit-component-dialog-v2';

type Props = {
    notification: {title: string, content: string},
    onClose: () => void,
};

export const PREVIEW_MODAL_WIDTH = 912;

export const PreviewModal = ({notification, onClose}: Props) => (
    <>
        <DialogHeader onClose={onClose}>
            {notification.title}
        </DialogHeader>
        <DialogMain style={{padding: 24}}>
            <NotificationContent
                width={864}
                maxHeight={460}
                content={notification.content}
            />
        </DialogMain>
        <DialogFooter>
            <Button variant="Type.SECONDARY" onClick={onClose}>
                Close
            </Button>
        </DialogFooter>
    </>
);
